import { type FC, useContext } from "react";

import { useHistory } from "react-router";

import { Button, Icon } from "@alpacahq/ui/old";

import { Path } from "../../path";
import { AppDetailsContext } from "./AppDetailsPage";

export const AppDetailsEdit: FC = () => {
  const history = useHistory();

  const {
    client: { client_id },
  } = useContext(AppDetailsContext);

  return (
    <Button
      onClick={() =>
        history.push(
          Path.format(Path.ROUTE_ALPACA_CONNECT_EDIT, { clientId: client_id }),
        )
      }
      className="flex"
    >
      <Icon name="PencilSquare" className="mr-2" />
      Edit App
    </Button>
  );
};
